import Invoices from './Invoices';

export default Invoices;
